var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isBase64 == false)?_c('qrcode-vue',{attrs:{"value":_vm.value,"size":_vm.size,"level":"H"}}):_c('img',{attrs:{"width":_vm.size,"height":_vm.size,"src":_vm.value,"alt":"qrcode"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }